import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { RequireAuth, RequireAdmin, RequireGuest, RequireAdminGuest } from "./guards";

import Login from "../pages/auth/Login";
import Signup from "../pages/auth/Signup";
import ForgotPassword from "../pages/auth/ForgotPassword";
import ResetPassword from "../pages/auth/ResetPassword";
import VerifyEmail from "../pages/auth/VerifyEmail";
import AdminLogin from "../pages/auth/AdminLogin";

import UserOverview from "../pages/user/Overview";
import UserPool from "../pages/user/MyPool";
import UserTickets from "../pages/user/MyTickets";
import UserResults from "../pages/user/Results";
import UserPayments from "../pages/user/Payments";
import UserSubscription from "../pages/user/Subscription";
import UserProfile from "../pages/user/Profile";

import AdminOverview from "../pages/admin/Overview";
import AdminUsers from "../pages/admin/Users";
import AdminPools from "../pages/admin/Pools";
import AdminTickets from "../pages/admin/Tickets";
import AdminResults from "../pages/admin/Results";
import AdminWinners from "../pages/admin/Winners";
import AdminPayments from "../pages/admin/Payments";
import AdminSettings from "../pages/admin/Settings";
import AdminAuditLogs from "../pages/admin/AuditLogs";
import AdminProfile from "../pages/admin/Profile";

export default function AppRouter() {
  return (
    <Routes>
      {/* User guest routes */}
      <Route element={<RequireGuest />}>
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
      </Route>

      <Route path="/reset-password/:token" element={<ResetPassword />} />
      <Route path="/verify-email/:token" element={<VerifyEmail />} />

      {/* Admin guest route */}
      <Route element={<RequireAdminGuest />}>
        <Route path="/admin/login" element={<AdminLogin />} />
      </Route>

      {/* User protected routes */}
      <Route element={<RequireAuth />}>
        <Route path="/dashboard" element={<UserOverview />} />
        <Route path="/dashboard/pool" element={<UserPool />} />
        <Route path="/dashboard/tickets" element={<UserTickets />} />
        <Route path="/dashboard/results" element={<UserResults />} />
        <Route path="/dashboard/payments" element={<UserPayments />} />
        <Route path="/dashboard/subscription" element={<UserSubscription />} />
        <Route path="/dashboard/profile" element={<UserProfile />} />
      </Route>

      {/* Admin protected routes */}
      <Route element={<RequireAdmin />}>
        <Route path="/admin" element={<AdminOverview />} />
        <Route path="/admin/users" element={<AdminUsers />} />
        <Route path="/admin/pools" element={<AdminPools />} />
        <Route path="/admin/tickets" element={<AdminTickets />} />
        <Route path="/admin/results" element={<AdminResults />} />
        <Route path="/admin/winners" element={<AdminWinners />} />
        <Route path="/admin/payments" element={<AdminPayments />} />
        <Route path="/admin/settings" element={<AdminSettings />} />
        <Route path="/admin/audit-logs" element={<AdminAuditLogs />} />
        <Route path="/admin/profile" element={<AdminProfile />} />
      </Route>

      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}
